import { setupSearch, setupMobileNav } from '../util/navigation';
import slideToggle from '../util/slideToggle';

export default {
  init: function() {
    // Handles the navigation
    setupMobileNav();
    setupSearch();
    document.querySelectorAll('.event-item-info').forEach(item => {
      item.addEventListener('click', () => {
        item
          .querySelectorAll(':scope > .details')
          .forEach(details => slideToggle(details, 200));
      });
    });
  },
  finalize: function() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
